import PageTransition from "./templateParts/PageTransition";

const Posts = () => {
  return (
    <PageTransition>
      <div>Posts</div>
    </PageTransition>
  );
};

export default Posts;
